import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { ProductDropdown, ResourcesDropdown } from './appbar_dropdown';
import { useNavigate } from 'react-router-dom';

function AppNavBar({ navType }) {
  const nav = useNavigate();
  const [isVisible, setToVisible] = useState({ product_menu: false, resources_menu: false });
  const toggleProductMenu = () => setToVisible({
    product_menu: !isVisible.product_menu, resources_menu: false
  });
  const toggleResourcesMenu = () => setToVisible({
    product_menu: false, resources_menu: !isVisible.resources_menu
  });
  const signInBtn = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
  const freeSignUpBtn = () => window.open("http://app.gokardinal.com/login", "_blank");

  return (
    <Navbar expand="lg" className={`_nav ${navType} nav0mob`}>
      <Container>
        <Navbar.Brand onClick={() => nav("/")}></Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll">
          <MenuIcon className='hamburg menu-icon' />
          <CloseIcon className='hamburg close-icon' />
        </Navbar.Toggle>
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0 appbarNavLinks"
            navbarScroll
          >
            <Nav.Link onClick={toggleProductMenu}>
              Product
              <ExpandMoreIcon fontSize='larger' />
            </Nav.Link>
            <ProductDropdown visibility={isVisible.product_menu} /> {/* dropdown */}
            <Nav.Link onClick={() => nav("/customer")}>Customers</Nav.Link>
            <Nav.Link onClick={toggleResourcesMenu}>
              Resources
              <ExpandMoreIcon fontSize='small' />
              <ResourcesDropdown visibility={isVisible.resources_menu} /> {/* dropdown */}
            </Nav.Link>
            <div className='mob0res'>
              <ResourcesDropdown visibility={isVisible.resources_menu} /> {/* dropdown */}
            </div>
          </Nav>
          <div className="d-flex">
            <button className='signInBtn' onClick={freeSignUpBtn}>Sign in</button>
            <button className='signInNowBtn' onClick={signInBtn}>Sign up now</button>
          </div>
          <Nav.Link onClick={() => nav("/contact")} className='navLink_contactSales'>Contact sales</Nav.Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavBar;